function getCommonButtons(small, producent, gotDevice) {
  const isSuperior = producent === 'spirotech';
  const isBlack = !small || isSuperior;
  let commonButtons = [
    {
      iconName: isBlack ? 'settings' : 'settings_white',
      text: 'profile_settings_header_text',
      link: '/profile/notifications',
    },
    {
      iconName: isBlack ? 'messages' : 'messages_white',
      text: 'basic_navigation_messages',
      link: '/messages',
    },
    {
      iconName: isBlack ? 'logout' : 'logout_white',
      text: 'logout_header_text',
      link: '/logout',
    },
  ]
  if (gotDevice) {
    commonButtons = [
      {
        iconName: isBlack ? 'settings' : 'settings_white',
        text: 'profile_settings_header_text',
        link: '/profile/notifications',
      },
      {
        iconName: isBlack ? 'messages' : 'messages_white',
        text: 'basic_navigation_messages',
        link: '/messages',
      },
      {
        iconName: isBlack ? 'notifications' : 'notifications_white',
        text: 'basic_navigation_notifications',
        link: '/notifications',
      },
      {
        iconName: isBlack ? 'logout' : 'logout_white',
        text: 'logout_header_text',
        link: '/logout',
      },
    ];
  }
  return commonButtons;
}

export function getAdminButtons(small, producent, ownershipCount) {
  const gotDevice = +ownershipCount > 0;
  const isSuperior = producent === 'spirotech';
  const isBlack = !small || isSuperior;
  const adminButtons = gotDevice 
    ? [
        {
          iconName: isBlack ? 'devices' : 'devices_white',
          text: 'device_list_header_text',
          link: '/',
        },
      ] : [
        {
          iconName: isBlack ? 'add' : 'add_white',
          text: 'add_new_device_submit_main_screen_text',
          link: '/newdevice',
        },
    ];
  return adminButtons.concat(getCommonButtons(small, producent, gotDevice));
}

export function getUserButtons(small, producent, ownershipCount) {
  const gotDevice = +ownershipCount > 0;
  const isSuperior = producent === 'spirotech';
  const isBlack = !small || isSuperior;
  const deviceListButton = gotDevice 
    ? [
      {
        iconName: isBlack ? 'devices' : 'devices_white',
        text: 'device_list_header_text',
        link: '/',
      },
    ] : [];
  const userButtons = deviceListButton.concat([
    {
      iconName: isBlack ? 'add' : 'add_white',
      text: 'add_new_device_submit_main_screen_text',
      link: '/newdevice',
    },
  ]);

  return userButtons.concat(getCommonButtons(small, producent, gotDevice));
}


// WEBPACK FOOTER //
// ./src/components/BasicNavigation/NavigationButtonsValues.js